export default class TransportsUtil {

    // <6h && >6min
    static isTransportDurationWithinLimits(transport) {
        if (
            (transport.end - transport.start) > 6 * 60 &&
            (transport.end - transport.start) < 6 * 60 * 60
        ) {
            return true;
        }

        return false;
    }

    // <2h
    static haccpCompliantDuration(doorClosedTimeStamp, doorOpenedTimeStamp) {
        if (doorOpenedTimeStamp - doorClosedTimeStamp < (2 * 60 * 60)) {
            return true;
        }
        return false;
    }

    // >2h && <2.5h
    static haccpCompliantWarningDuration(doorClosedTimeStamp, doorOpenedTimeStamp) {
        if (
            doorOpenedTimeStamp - doorClosedTimeStamp > (2 * 60 * 60) &&
            doorOpenedTimeStamp - doorClosedTimeStamp < ((2 * 60 * 60) + (30 * 60))
        ) {
            return true;
        }
        return false;
    }

    // >= 2.5h
    static haccpNotCompliantDuration(doorClosedTimeStamp, doorOpenedTimeStamp) {
        if (doorOpenedTimeStamp - doorClosedTimeStamp >= ((2 * 60 * 60) + (30 * 60))) {
            return true;
        }
        return false;
    }

    static unixToLocalTime(unixTime) {
        return new Date(unixTime * 1000).toLocaleString('sv-SE');
    }

    static badTemperature(state) {
        return state.box_temperature > 8 && state.box_temperature < 60;
    }

    static complianceStartedNotEnded(transport) {
        return transport.complianceStart && !transport.complianceEnd;
    }

    static graphStart(transport) {
        // Earliest of powerOff and complianceStart (door_close), but max 3h before powerOff
        let begin = 0;
        if (!transport.complianceStart) {
            begin = transport.start;
        } else {
            begin = transport.complianceStart < (transport.start - (3 * 60 * 60)) ? (transport.start - (3 * 60 * 60)) : transport.complianceStart;
        }
        return (Math.min(transport.start, begin) * 1000) - (60000 * 5); // -5min
    }

    static graphEnd(transport) {
        // Latest of powerOn and complianceEnd (door_open), but max 3h after powerOn
        let finish = 0;
        if (!transport.complianceEnd) {
            finish = transport.end;
        } else {
            finish = transport.complianceEnd > (transport.end + (3 * 60 * 60)) ? (transport.end + (3 * 60 * 60)) : transport.complianceEnd;
        }
        return (Math.max(transport.end, finish) * 1000) + (60000 * 5); // +5min
    }
}



// WEBPACK FOOTER //
// ./src/app/components/transports/transports-util.js